<div class="deactivate__payment">
  <div class="deactivate__payment__title vc-text-l" i18n="@@GET_PAID.DEACTIVATE_POPIN.TRANSFERT_METHOD">
    Tranfer method
  </div>
  <div class="deactivate__payment__text vc-text-m" i18n="@@GET_PAID.DEACTIVATE_POPIN.CONTENT">
    By updating, your previous Paypal account details will erased and replaced with the new one.
  </div>
  <div class="deactivate__payment__button">
    <button
      class="vc-btn vc-btn--outline vc-btn--medium"
      (click)="dialogRef.close()"
      i18n="@@GET_PAID.DEACTIVATE_POPIN.CANCEL"
    >
      Cancel
    </button>
    <button
      class="vc-btn vc-btn--primary vc-btn--medium"
      (click)="deleteOldTransferMethod()"
      i18n="@@GET_PAID.DEACTIVATE_POPIN.BUTTON"
    >
      Continue
    </button>
  </div>
</div>
